import React from 'react'
import jsPDF from "jspdf";
import "jspdf-autotable";
import exportToCSV from "../exportToCsv"
import { toast } from 'react-toastify';
import ControlService from "../controlservice";

export const updateFilter = (e, control, tempData) => {
    const val = e.target.value.toLowerCase();
    var temp = [];
    if (control.filtercolumns.length === 1) {
        let col1 = control.filtercolumns[0];
        temp = tempData.filter(function (d) {
            return (d[col1] && d[col1].toLowerCase().indexOf(val) !== -1) || !val;
        });

    } else if (control.filtercolumns.length === 2) {
        let col1 = control.filtercolumns[0];
        let col2 = control.filtercolumns[1];
        temp = tempData.filter(function (d) {
            return (d[col1] && d[col1].toLowerCase().indexOf(val) !== -1) || (d[col2] && d[col2].toLowerCase().indexOf(val) !== -1) || !val;
        });
    } else if (control.filtercolumns.length === 3) {
        let col1 = control.filtercolumns[0];
        let col2 = control.filtercolumns[1];
        let col3 = control.filtercolumns[2];
        temp = tempData.filter(function (d) {
            return (d[col1] && d[col1].toLowerCase().indexOf(val) !== -1) || (d[col2] && d[col2].toLowerCase().indexOf(val) !== -1) || (d[col3] && d[col3].toLowerCase().indexOf(val) !== -1) || !val;
        });
    } else if (control.filtercolumns.length === 4) {
        let col1 = control.filtercolumns[0];
        let col2 = control.filtercolumns[1];
        let col3 = control.filtercolumns[2];
        let col4 = control.filtercolumns[3];
        temp = tempData.filter(function (d) {
            return (d[col1] && d[col1].toLowerCase().indexOf(val) !== -1) || (d[col2] && d[col2].toLowerCase().indexOf(val) !== -1) || (d[col3] && d[col3].toLowerCase().indexOf(val) !== -1) || (d[col4] && d[col4].toLowerCase().indexOf(val) !== -1) || !val;
        });
    } else if (control.filtercolumns.length === 5) {
        let col1 = control.filtercolumns[0];
        let col2 = control.filtercolumns[1];
        let col3 = control.filtercolumns[2];
        let col4 = control.filtercolumns[3];
        let col5 = control.filtercolumns[4];
        temp = tempData.filter(function (d) {
            return (d[col1] && d[col1].toLowerCase().indexOf(val) !== -1) || (d[col2] && d[col2].toLowerCase().indexOf(val) !== -1) || (d[col3] && d[col3].toLowerCase().indexOf(val) !== -1) || (d[col4] && d[col4].toLowerCase().indexOf(val) !== -1) || (d[col5] && d[col5].toLowerCase().indexOf(val) !== -1) || !val;
        });
    }

    return temp;
}
export const Export = async (control, token, apiData, isPdf) => {
    debugger;
    var columns = [];
    if (isPdf) {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        let createFileName = (exportFileName) => {
            var date = new Date();
            return (exportFileName +
                date.toLocaleDateString() + "_" +
                date.toLocaleTimeString()) + '.pdf'
        }
        const title = control.label;

        control.ResultDisplayField.forEach(item => {
            columns.push(item.BindingField);
        });
        const headers = [columns];

        const data = apiData.map(elt => columns.map(col=>elt[col]));

        let content = {
            startY: 50,
            head: headers,
            body: data
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save(createFileName(control.label))
    } else {
        control.ResultDisplayField.forEach(item => {
            var arr = {}
            arr.name = item.DisplayName;
            arr.prop = item.BindingValueField && item.BindingValueField.trim() ? item.BindingValueField : item.BindingField;
            if (arr.name && arr.prop) {
                if (item.fieldtype == "date") {
                    arr.type = "date";
                }
                else {
                    arr.type = "text";
                }
                columns.push(arr);
            }
        });
        exportToCSV().generatecsvReport(columns, apiData, control.exportfilename ? control.exportfilename : control.label);
    }
}
export const deleteItem = async (control, token, selected) => {
    let apiparam = {};
    control.deleteapiparam.forEach(option => {
        apiparam[option.key] = option.value;
    })
    control.headers = control.deleteheaders;
    control.connection = control.deleteconnection;
    control.datasource = control.deletesource;
    control.payload = control.deletepayload
    control.model = control.deletemodel
    control.workflowname = control.deleteworkflowname
    control.function = control.deletefunction
    if (control.deletemethod) {
        control.method = control.deletemethod;
    } else {
        control.method = "post";
    }
    if (control.deletesource || control.deleteapi) {
        try {
            await ControlService().ServiceRequest(control.deleteapi, apiparam, control, token, selected)
            toast.success(<Message message="Successfully deleted!" />)
        }
        catch (err) {
            toast.error(<Message message={err.message} type="error" />)
        }
    } else {
        toast.error(<Message message="API configuration missing" type="error" />)
    }
}
export const updateItem = async (control, data, token, Id) => {
    let apiparam = {};
    control.updateapiparam.forEach(option => {
        apiparam[option.key] = option.value;
    })
    control.headers = control.updateheaders;
    control.connection = control.updateconnection;
    control.datasource = control.updatesource;
    control.payload = control.updatepayload
    control.model = control.updatemodel
    control.workflowname = control.updateworkflowname
    control.function = control.updatefunction
    if (control.updatemethod) {
        control.method = control.updatemethod;
    } else {
        control.method = "post";
    }
    var { selected } = this.state;
    var _data = data[Id + 'write'] ? data[Id + 'write'] : {};
    this.state.updselectedItems.map(item => {
        selected.map(row => {
            row[item.value] = _data[item.value];
        })
    })
    var updateDataModel = null
    if (this.state.addingroup) {
        updateDataModel = {}
        updateDataModel[control.groupfield] = selected;
    } else {
        updateDataModel = selected;
    }
    if (control.updatesource || control.updateapi) {
        try {
            await ControlService().ServiceRequest(control.updateapi, apiparam, control, token, updateDataModel)
            toast.success(<Message message="Successfully updated!" />)
        }
        catch (err) {
            toast.error(<Message message={err.message} type="error" />)
        }
    } else {
        toast.error(<Message message="API configuration missing" type="error" />)
    }
}
export const renderNoDataImage = (control) => {
    return (
        <div className="no-data-box d-flex justify-content-center text-center align-items-center align-content-center flex-column" style={{ 'minHeight': control.nodataheight + "px", 'backgroundColor': control.nodatabgcolor }}>
            {control.nodataimage &&
                <div className="mb-3">
                    <img src={control.nodataimage} className="img-fluid" width="100" height="100" alt='No Data' style={{ 'width': control.nodataimagewidth + "px" }} />
                </div>
            }
            <h3 className="text-dark">{control.nodatatitle ? control.nodatatitle : 'No Data Available!'}</h3>
            {control.nodatamsg &&
                <p className="m-0" >{control.nodatamsg}</p>
            }
        </div>
    )
}